import { render } from "./PromotionCard.vue?vue&type=template&id=b0aba744"
import script from "./PromotionCard.vue?vue&type=script&lang=js"
export * from "./PromotionCard.vue?vue&type=script&lang=js"
script.render = render

export default script